(() => {
  'use strict';
  function initialise(root = document) {
    root.querySelectorAll('.emberkin-interest-form').forEach((form) => {
      if (form.dataset.initialised) return;
      form.dataset.initialised = 'true';
      const tags = form.querySelector('[data-interest-tags]');
      const sync = () => {
        const selected = Array.from(form.querySelectorAll('[data-interest]:checked'), (input) => input.value);
        tags.value = ['newsletter', 'emberkin-prelaunch-v2', ...new Set(selected)].join(',');
      };
      form.querySelectorAll('[data-preferences]').forEach((group) => { group.disabled = false; });
      form.addEventListener('change', sync);
      form.addEventListener('submit', sync);
      form.addEventListener('formdata', (event) => { sync(); event.formData.set('contact[tags]', tags.value); });
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
